import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import SeoHead from "@/components/base/SeoHead";
import HeroSection from "./components/HeroSection";
import AboutSection from "./components/AboutSection";
import CategoryGrid from "./components/CategoryGrid";
import FeaturedProducts from "./components/FeaturedProducts";
import TestimonialSection from "./components/TestimonialSection";
import CTASection from "./components/CTASection";
import ArticleLinks from "./components/ArticleLinks";

const homeJsonLd = [
  {
    "@type": "WebSite",
    name: "CSSBuy Spreadsheet",
    url: "https://cssbuyspreadsheet.link/",
    description: "O guia mais completo de CSSBuy Spreadsheet em português — planilhas, tutoriais, comparações e dicas para comprar da China em 2026.",
    inLanguage: "pt",
    potentialAction: {
      "@type": "SearchAction",
      target: "https://cssbuyspreadsheet.link/search?q={search_term_string}",
      "query-input": "required name=search_term_string",
    },
  },
  {
    "@type": "FAQPage",
    mainEntity: [
      {
        "@type": "Question",
        name: "O que é uma CSSBuy Spreadsheet?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Uma CSSBuy Spreadsheet é uma planilha organizada que reúne centenas de links de produtos de plataformas chinesas como Taobao, Weidian e 1688, criada por compradores experientes e organizada por categorias como tênis, roupas e acessórios.",
        },
      },
      {
        "@type": "Question",
        name: "CSSBuy é seguro?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Sim, o CSSBuy atua como intermediário em todas as transações, oferecendo fotos QC para verificação de qualidade antes do envio e um sistema de disputas transparente para proteger o comprador.",
        },
      },
      {
        "@type": "Question",
        name: "Quanto custa usar o CSSBuy?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "O CSSBuy cobra uma taxa de serviço de 4-6% sobre o valor do produto mais frete internacional. A conta é gratuita e você pode usar planilhas gratuitas para encontrar produtos.",
        },
      },
    ],
  },
];

export default function Home() {
  return (
    <>
      <SeoHead
        title="CSSBuy Spreadsheet - Melhor Guia Completo 2026 | Planilhas, Dicas e Comparações"
        description="O guia mais completo de CSSBuy Spreadsheet em português. Encontre as melhores planilhas CSSBuy, tutoriais passo a passo, comparações de plataformas, dicas de envio e como economizar nas suas compras da China em 2026."
        keywords="cssbuy spreadsheet, cssbuy guia, cssbuy portugal, cssbuy brasil, planilha cssbuy, comprar na china, agente de compras china, spreadsheet china shopping"
        canonicalPath="/"
        jsonLd={homeJsonLd}
      />
      <Navbar />
      <main>
        <HeroSection />
        <AboutSection />
        <CategoryGrid />
        <FeaturedProducts />
        <TestimonialSection />
        <CTASection />
        <ArticleLinks />
      </main>
      <Footer />
    </>
  );
}